'use strict';

var React = require('react');
var index = require('../Flex/index.js');
var component = require('../Icon/component.js');
require('../Tooltip/component.js');
var component$1 = require('../Text/component.js');
var styles = require('./styles.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

const coloredCardColorByVariant = {
    error: 'red',
    info: 'blue',
    success: 'green',
    warning: 'orange',
};
const iconNameByVariant = {
    error: 'ban-filled',
    info: 'info-circle-outlined',
    success: 'validate-circle-outlined',
    warning: 'alert-circle-outlined',
};
const Banner = React.forwardRef(({ variant, heading, body, footer, onClose, ...props }, ref) => (React__default.default.createElement(styles.Styled.ColoredCard, { ...props, color: coloredCardColorByVariant[variant], ref: ref },
    onClose && (React__default.default.createElement(styles.Styled.CloseIconContainer, { "aria-label": "close", role: "button", onClick: onClose },
        React__default.default.createElement(component.Icon, { name: "clear-filled" }))),
    React__default.default.createElement(styles.Styled.FlexRow, { space: "m", alignItems: "flex-start" },
        React__default.default.createElement(styles.Styled.VariantIconContainer, null,
            React__default.default.createElement(component.Icon, { name: iconNameByVariant[variant] })),
        React__default.default.createElement(index.Flex.Column, { space: "m" },
            React__default.default.createElement(index.Flex.Column, { space: "xs" },
                React__default.default.createElement(styles.Styled.HeadingText, { variant: "body", closeable: !!onClose }, heading),
                React__default.default.createElement(component$1.Text, { variant: "body-lighter" }, body)),
            footer && React__default.default.createElement("div", null, footer))))));

exports.Banner = Banner;
//# sourceMappingURL=component.js.map
